import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Button,    
} from "reactstrap";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import {PASSWORD_REGEXP} from '../../settings/shared/constants'
import { toast } from 'react-toastify';
import UserService from '../../services/api/User'
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';


const styles = {
  errorBox:{
    textAlign:"center",
    marginBottom:20
  },
  error:{
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius:6
  },
  passwordHint:{
    color:"gray",
    fontSize:12
  }
}
class ChangePassword extends React.Component {

  constructor(props) {
    super(props)     
    this.state = { 
    errorSubmitted:false,
    passswordChecker:'poor',
    oldPass:'',
    newPass:'',
    confirmPass:'',
    errorMessage:'',
    swidth: window.innerWidth,
    sheight: window.innerHeight
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

}

 componentDidMount() {
  this.updateWindowDimensions();
  window.addEventListener('resize', this.updateWindowDimensions);
  
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }


  setErrorMessage(message){
     if(message === ""){
       this.setState({
         errorMessage:message,
         errorSubmitted:false
       })
     }else{
    document.getElementById('errorDiv').scrollIntoView()
     this.setState({
       errorMessage:message,
       errorSubmitted:true
     });
     }
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    switch (name) {
      case 'newPass': 
        if(PASSWORD_REGEXP.test(value)){
          this.setState({
            passswordChecker:"strong"
          })
        }
        else if(value.length===0 || value===undefined){
          this.setState({
            passswordChecker:"poor"
          })
        }
        else if(value.length===6){
          this.setState({
            passswordChecker:"weak"
          })
        }
        else if(value.length===7){
          this.setState({
            passswordChecker:"medium"
          })
        }
      break;
      default:
        break;
    }
      this.setState({ [name]: value});
  }

  // Submit user Data
  SubmitPasswordChange = (event) => {
    event.preventDefault();
    
      if(this.state.oldPass==="" || this.state.oldPass===undefined){
         this.setErrorMessage("Please Enter Old Password");
      }
      else if(this.state.newPass==="" || this.state.newPass===undefined){
         this.setErrorMessage("Please Enter New Password");
      }
      else if(this.state.newPass.length < 8){
         this.setErrorMessage("Password must be 8 characters long!");
      }
      else if(!PASSWORD_REGEXP.test(this.state.newPass)){
            this.setErrorMessage("Password Policy does not match");
      }
      else if(this.state.oldPass === this.state.newPass===undefined){
          this.setErrorMessage("New password must differ from old password");
      }
      else if(this.state.confirmPass==="" || this.state.confirmPass===undefined){
         this.setErrorMessage("Please Enter Confirm Password");
      }
      else if(this.state.newPass !== this.state.confirmPass){
          this.setErrorMessage("Password mismatch!");
      }
       else{
         this.setErrorMessage("");
          if(!this.state.errorSubmitted) {     
                let post ={
                oldPassword:this.state.oldPass,
                newPassword:this.state.newPass,
              }
              // console.log(JSON.stringify(post));
                //Post change password service integration
                UserService.UpdatePassword(post)
                .then((response) => {
                    if (response.status === 'SUCCESS') {
                    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Password Changed Successfully!</b></i>); 
                    this.clearformData();   // Reset Form data    
                    } else {
                      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
                      this.clearformData();   // Reset Form data    
                    }
                });
                  }else{
                    console.error('Invalid Form')
                  }
      }  
  }

  // Reset form data
  clearformData(){
    this.setState({
      oldPass:'',
      newPass:'',
      confirmPass:'',
      passswordChecker:'poor'
    })
  }


  render() {
    return (
   
      <>
      <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        {/* Page content */}
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <div className=" col" id="errorDiv">
              <Card className=" shadow">
                <CardHeader className=" bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Change Password</h3>
                    </div>
                  </Row>
               </CardHeader>
                <CardBody>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <div className="carcontent">
                    {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                    <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
                  <Form onSubmit={this.SubmitPasswordChange} noValidate>
                    <div className="pl-lg-4">
                        <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        Old Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="Old Password"
                                    name="oldPass"
                                    value={this.state.oldPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    </FormGroup>
                                
                                </Col>
                      </Row>
                      <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        New Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="New Password"
                                    name="newPass"
                                    value={this.state.newPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    <div className="text-muted font-italic">
                                <small>
                                    password strength:{" "}
                                    <span className="text-success font-weight-700">{this.state.passswordChecker}</span>
                                </small>
                                </div>
                                    </FormGroup>
                                </Col>
                      </Row>
                      <Row>
                                <Col lg="6">
                                
                                <FormGroup>
                                        <label
                                        className="form-control-label"
                                        htmlFor="input-email"
                                        >
                                        Confirm Password
                                        </label>
                                        <Input
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    name="confirmPass"
                                    value={this.state.confirmPass}
                                    type="password"
                                    onChange={this.handleChange}/>
                                    </FormGroup>
                <span style={styles.passwordHint}>Use 8 or more characters with a mix of one UpperCase, LowerCase, numbers & symbols</span>
                                </Col>
                      </Row>
                          
                    </div>
                    <hr className="my-4" />
                    <Row className="stickybuttons">  
                    <Col lg="1">
                    <FormGroup>
                     <Button
                       color="primary"
                       size="sm"
                       type="submit"
                       onClick={e=>this.clearformData()}
                     >
                       Clear
                     </Button>
                     </FormGroup>
                     </Col>
                       <Col lg="1">
                       <FormGroup>
                     <Button
                       color="primary"
                       size="sm"
                     >
                       Submit
                     </Button>
                     </FormGroup>
                     </Col>
                    </Row>
                    </Form>
                </div>
                    </Scrollbars>
                </CardBody>
              </Card>
            </div>
          </Row>
          </LoadingOverlay>
        </div>
      </>
    );
  }
}

export default ChangePassword;
